<template>
	<LoginLayout
		heading="Account locked out"
	>
		<template #form>
			<div class="text-center">
				<div class="login-icon-roundel mb-6">
					<v-icon size="32">
						mdi-lock-outline
					</v-icon>
				</div>
			</div>
			<Message>
				Your account is locked out
			</Message>
			<a @click="$router.push({ path: '/forgotten-password' })">
				Please click here to reset your password.
			</a>
		</template>
	</LoginLayout>
</template>
<script>
import LoginLayout from '../../../../../shared/layouts/login-layout.vue'
import Message from '../../../../../shared/components/message.vue'
export default {
	components: { Message, LoginLayout }
}
</script>
